var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "website-chatbot-builder" },
    [
      [
        _vm.STATES.TRAINING,
        _vm.STATES.ATTRIBUTES_CALCULATING,
        _vm.STATES.CHATBOT_CREATING,
        _vm.STATES.SCRAPPING,
        _vm.STATES.TUNING_CHATBOT,
      ].includes(_vm.state)
        ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-wrapper" }, [
        _c("div", { staticClass: "steper-header" }, [
          _vm.state !== "not-started"
            ? _c("div", { staticClass: "state-viewer" }, [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    class: {
                      spin: [
                        _vm.STATES.TRAINING,
                        _vm.STATES.ATTRIBUTES_CALCULATING,
                        _vm.STATES.CHATBOT_CREATING,
                        _vm.STATES.SCRAPPING,
                        _vm.STATES.TUNING_CHATBOT,
                      ].includes(_vm.state),
                    },
                  },
                  [_vm._v("autorenew")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.getStateText()))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "top-navigation" }, [
            _c("div", { staticClass: "step" }, [
              _c("i", { staticClass: "completed material-icons" }, [
                _vm._v("check"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.setupChatbot"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "step" }, [
              _vm.activeStep === 3
                ? _c("i", { staticClass: "completed material-icons" }, [
                    _vm._v("check"),
                  ])
                : _c("div", { staticClass: "number" }, [_vm._v("2")]),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.train"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "step", class: { inactive: _vm.activeStep < 3 } },
              [
                _c("div", { staticClass: "number" }, [_vm._v("3")]),
                _vm._v(" "),
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.tuneChatbot"))),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "traning" },
          [
            _vm.activeStep === 2
              ? _c("WebsiteTrain", {
                  attrs: { builderMode: "" },
                  on: {
                    state: _vm.updateState,
                    "scrapper-state": function (data) {
                      return (_vm.scrapperState = data)
                    },
                  },
                  model: {
                    value: _vm.url,
                    callback: function ($$v) {
                      _vm.url = $$v
                    },
                    expression: "url",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.activeStep === 3
              ? _c("TuneChatbot", {
                  model: {
                    value: _vm.tuningParams,
                    callback: function ($$v) {
                      _vm.tuningParams = $$v
                    },
                    expression: "tuningParams",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer-actions" },
        [
          _c(
            "SupsisButton",
            { attrs: { ghost: "", xlarge: "" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("message.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: {
                primary: "",
                xlarge: "",
                disabled: !_vm.isNextEnabled(),
              },
              on: { click: _vm.next },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.activeStep === 3
                      ? _vm.$t("chatbotv2.complete")
                      : _vm.$t("chatbotv2.continue")
                  ) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "background-accent" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }